import React from 'react';
import ArrowIcon from '../../../../../../../images/icons/arrow';

import Index from 'gatsby-ppc-theme/src/components/molecules/header/variants/toplist/template-one';

export default ( props) => <Index {...props}  buttonIcon = {<ArrowIcon />} />;